import { render, staticRenderFns } from "./BangkokOfficer.vue?vue&type=template&id=b33e8fc6&"
import script from "./BangkokOfficer.vue?vue&type=script&lang=js&"
export * from "./BangkokOfficer.vue?vue&type=script&lang=js&"
import style0 from "./BangkokOfficer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports